import { Box, Center, Spinner } from "@chakra-ui/react";
import { LOADER_STYLES } from "@constants/index";
import { FC } from "react";

export const Loader: FC<ILoader> = ({
  size = LOADER_STYLES.size,
  mt = "0px",
  color = "theme.button.primary",
  thickness = LOADER_STYLES.thickness,
}) => (
  <Box height="100vh">
    <Center mt={mt} height="100%">
      <Spinner size={size} color={color} thickness={thickness} />
    </Center>
  </Box>
);
